import { Select, Row, Col } from "antd";
import { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { getQuickTimeRange } from "../../DateTimeUtils";
import "./style.css";

const { Option } = Select;

const getDropDownOptions = () => {
  const selectOptions = [
    {
      key: "today",
      text: "Today",
      range: getQuickTimeRange("string", "today"),
    },
    {
      key: "yesterday",
      text: "Yesterday",
      range: getQuickTimeRange("string", "yesterday"),
    },
    {
      key: "thisWeek",
      text: "This Week",
      range: getQuickTimeRange("string", "thisWeek"),
    },
    {
      key: "lastWeek",
      text: "Last Week",
      range: getQuickTimeRange("string", "lastWeek"),
    },
    {
      key: "thisMonth",
      text: "This Month",
      range: getQuickTimeRange("string", "thisMonth"),
    },
    {
      key: "lastMonth",
      text: "Last Month",
      range: getQuickTimeRange("string", "lastMonth"),
    },
  ];
  return selectOptions;
};

const QuickTimeRange = ({ timeRange, showText = true, onTimeFilterChange }) => {
  const [dropDownOptions, setDropDownOptions] = useState(getDropDownOptions);
  const [selectedOption, setSelectedOption] = useState("thisWeek");
  const isSmallScreen = useMediaQuery({ query: "(max-width: 1220px)" });

  const handleChange = (value) => {
    setSelectedOption(value);
    onTimeFilterChange(value);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDropDownOptions(getDropDownOptions);
    }, 60 * 1000);
    return () => clearInterval(intervalId);
  }, []);

  const dropDownClass =
    showText && isSmallScreen
      ? "time-range-dropdown-small"
      : "time-range-dropdown-large";
  return (
    <div className="time-range-container">
      <div>
        <Select
          value={selectedOption}
          className={dropDownClass}
          onChange={handleChange}
        >
          {dropDownOptions.map((option, index) => {
            return (
              <Option key={index} value={option?.key}>
                <Row gutter={[8, 8]} wrap={false} justify={"space-between"}>
                  <Col>{option?.text}</Col>
                  {showText && !isSmallScreen ? (
                    <Col className="time-range-text">{option?.range}</Col>
                  ) : null}
                </Row>
              </Option>
            );
          })}
        </Select>
      </div>
    </div>
  );
};

export default QuickTimeRange;
